module.exports = __webpack_public_path__ + "img/2.0e91af78.png";